module.exports = __webpack_public_path__ + "2eea9a694cd4e56855d6eb0ed218fee1.svg";